export default __webpack_public_path__ + "static/media/disabled-access.bb136e23.svg";